import Cookies, { CookieAttributes } from 'js-cookie'

export const getIsAuthenticated = () => Cookies.get('authenticated')

export const setCookie = (name: string, value: string, options?: CookieAttributes) => Cookies.set(name, value, options)
